const faqs = [
  {
    q: '51吃瓜网在线观看是什么？',
    a: '51吃瓜网在线观看是一个专注于娱乐八卦资讯聚合与导航的一站式平台，提供51吃瓜网最新官网入口、网站地址及全网热门娱乐资讯，帮助用户快速找到正版官方入口并获取最新吃瓜内容。',
  },
  {
    q: '如何找到51吃瓜网最新网址和入口？',
    a: '你可以直接访问本页面（51吃瓜网在线观看官网），我们全天候更新维护51吃瓜网站入口与最新网址。当官方入口发生变化时，我们会在第一时间同步更新，建议将本页加入书签以便随时访问。',
  },
  {
    q: '51吃瓜网是否需要注册或付费？',
    a: '51吃瓜网作为娱乐资讯导航平台，浏览资讯和访问入口完全免费，无需注册或付费。我们致力于为广大用户提供便捷的吃瓜体验，没有任何隐藏收费项目。',
  },
  {
    q: '51吃瓜网的内容来源是否可靠？',
    a: '我们聚合的内容均来自微博、抖音、小红书等主流社交平台以及各大权威娱乐媒体的公开报道和资讯，经过人工审核筛选后呈现。平台入口也全部指向官方正版站点，确保用户访问安全可靠。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于51吃瓜网，你想知道的都在这里</p>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0">Q</span>
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-6">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}